import { getQueryMethod, resources, entities, methods } from '../utils';
const { meloAPI } = resources;
const { agreements } = entities;
const { POST, PATCH } = methods;

const query = getQueryMethod(meloAPI, agreements);

const endpoints = {
  getAgreementsCategories: async () => {
    return await query('categories');
  },
  getMoviiAgreements: async categoryId => {
    return await query(`?categoryId=${categoryId}`);
  },
  getBusinessAgreements: async businessId => {
    return await query(`business/${businessId}`);
  },
  deleteBusinessAgreements: async (businessId, agreements) => {
    return await query('delete', PATCH, { businessId, agreements });
  },
  payAgreements: async body => {
    return await query('pay', POST, body);
  },
  getAgreementsPayoutVoucher: async (businessId, payoutId) => {
    return await query(`voucher/payout/${businessId}/${payoutId}`);
  },
  getAgreementPayoutVoucher: async (businessId, { payoutId, agreementId, referenceId }) => {
    return await query(`voucher/agreement/${businessId}/${payoutId}/${agreementId}/${referenceId}`);
  }
};

export default endpoints;
